mod.modules.define("CurrentListDrawerLeft", "BaseDrawer", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.addPlugin("Plugin-Paging");

		if (params.open) {
			this.action_unDock();
		}

		this.initPreviews(
			this.el.find("span[data-auto-symbol]")
		);
	};

	fn.prototype.initPreviews = function($links) {
		var options = {
			delay: {
				show: 500,
				hide: 250
			},
			onShow: $.proxy(this.tooltipOnShow, this),
			onHide: $.proxy(this.tooltipOnHide, this),
			ListId: this.getContext().ListId
		};

		// Handle the events differently if we're browsing on mobile
		if ($(document.body).hasClass("mobile-browser")) {
			options.showEvent = "taphold";
		}
		
		this.previews = [];

		for (var i = $links.length - 1; i >= 0; i--) {
			var $el = $links.eq(i);
			options.symbol = $el.attr("data-auto-symbol");

			var preview = $el.symbolPreview(options);
			this.previews.push(preview);
		}
	};

	fn.prototype.tooltipOnShow = function() {
		this.preventDocking = true;
	};

	fn.prototype.tooltipOnHide = function() {
		var self = this;
		this.preventDocking = false;

		setTimeout(function() {
			if (!self.preventDocking && !self.isHoveredOver) {
				self.action_dock();
			}
		}, 50);
	};

	fn.prototype.onDock = function() {
		for (var i = 0; i < this.previews.length; i++) {
			this.previews[i].symbolPreview("abort");
		}
	};

	fn.prototype.observables = {
		"list changed": function() {
			this.reloadQueue();
		}
	};

	fn.prototype.events = {
		"[data-auto-symbol]": {
			"click": function(e, $el) {
				$el.symbolPreview("abort");
			}
		}
	};

});